import {ReferenceUnitMap} from "../interfaces/store/actions/payload/fileValidation";
import {DefaultMediaProperties} from "../interfaces/store/actions/payload/uploadFiles";

export const COMPLETE_EVENT: string = "COMPLETE";
export const REJECT_EVENT: string = "REJECT";

export const FILE_CHUNK_SIZE: number = 10000000; // ~10MB;

export const UPLOADS_REFERENCE_TRANSLATION_PATH: string = "_configurableValidation._uploadsReference";
export const MAKE_MODEL_INVALID_TRANSLATION_PATH: string = "_configurableValidation._exif_make_and_model.text";
export const EXIF_WIDTH: string = "Width";
export const EXIF_HEIGHT: string = "Height";
export const EXIF_ASPECT_RATIO: string = "AspectRatio";
export const EXIF_MAKE: string = "Make";
export const EXIF_MODEL: string = "Model";
export const EXIF_RESOLUTION: string = "Resolution";
export const FILE_VALIDATION_CHUNK_SIZE: number = 20;
export const HEIC_MIME_TYPE: string = "image/heic";
export const HEIC_FILE_EXTENSION: string = "HEIC";

export const HTML_SUPPORTED_VIDEO: string[] = [
    "video/x-matroska",
    "video/ogg",
    "video/quicktime",
    "video/mp4",
    "video/3gpp",
    "video/webm",
    "video/x-flv",
];
export const HTML_SUPPORTED_IMAGE: string[] = [
    "image/apng",
    "image/avif",
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "image/webp",
];
export const HTML_SUPPORTED_AUDIO: string[] = [
    "audio/wav",
    "audio/mpeg",
    "audio/mp4",
    "audio/aac",
    "audio/aacp",
    "audio/ogg",
    "audio/webm",
    "audio/ogg",
    "audio/flac",
];

export const REFERENCE_UNIT_MAP: ReferenceUnitMap = {
    Width: "pixels",
    Height: "pixels",
    Resolution: "megapixels",
    Duration: "seconds",
    FileSize: "bytes",
    StreamSize: "bytes",
    FrameRate: "frames per second",
    BitRate: "bits per second",
    OverallBitRate: "bits per second",
    Stored_Height: "pixels",
    Sampled_Width: "pixels",
    Sampled_Height: "pixels",
    FrameCount: "frames",
};

export const HTML_SUPPORTED_FILE_EXTENSIONS: string[] = [
    "apng",
    "avif",
    "gif",
    "jpeg",
    "jpg",
    "jfif",
    "pjpeg",
    "pjp",
    "png",
    "svg",
    "webp",
    "wav",
    "mpeg",
    "mp4",
    "aac",
    "aacp",
    "ogg",
    "webm",
    "ogg",
    "flac",
];

export const ENTER_KEY: string = "Enter";
export const ARROW_LEFT_KEY: string = "ArrowLeft";
export const ARROW_RIGHT_KEY: string = "ArrowRight";
export const ARROW_UP_KEY: string = "ArrowUp";
export const ARROW_DOWN_KEY: string = "ArrowDown";
export const ESCAPE_KEY: string = "Escape";
export const SPACE_KEY: string = " ";
export const TAB_KEY: string = "Tab";

// matches the end of string => .mp4
export const VIDEO_EXTENSION_REGEX: RegExp = new RegExp("(.mp4)$");
// matches the end of string => .mp3 || .wav
export const AUDIO_EXTENSION_REGEX: RegExp = new RegExp("(.mp3|.wav)$");
// public resource S3 bucket
export const PUBLIC_S3_BUCKET: RegExp = new RegExp("/static-resources/");
// default props for video and audio HTML tags
export const DEFAULT_MEDIA_PROPERTIES: DefaultMediaProperties = {
    controls: "controls",
    controlsList: "nodownload", // does not allow media (audio/video) to be downloaded
    onerror: undefined,
};
